/**
 * A patient as the pickers list it: "Dakota · P-00012". MUI filters options by their label, so
 * carrying the ID in it lets the front desk find a horse by the ID on its paperwork.
 */
export function patientLabel(horse: { name: string; patientId?: string | null }): string {
  return horse.patientId ? `${horse.name} · ${horse.patientId}` : horse.name;
}
